import type { RateLimitError, RateLimitErrorResponse } from '../../types/messages';

import { HTTP_STATUS_TOO_MANY_REQUESTS } from '../../constants/api';

/**
 * Проверяет статус ответа на rate limit и выбрасывает соответствующую ошибку
 */
export const checkRateLimit = async (response: Response): Promise<void> => {
  if (response.status === HTTP_STATUS_TOO_MANY_REQUESTS) {
    let errorData: RateLimitError | null = null;
    try {
      errorData = await response.json();
    } catch {
      // Игнорируем ошибку парсинга
    }
    throw { isRateLimit: true, errorData } as RateLimitErrorResponse;
  }
};
